export const filterCopy = {
  emptyLabels: {
    all: 'All',
    allFailureDetails: 'All Failure Details',
    allFailureKinds: 'All Failure Types',
    allFeatureStatuses: 'All Feature Statuses',
    allProjects: 'All Projects',
    allStatuses: 'All Statuses',
    allTags: 'All Tags',
    allTestingStatuses: 'All Testing Statuses',
    loadingTags: 'Loading Tags...',
    noSuites: 'No Suites',
    projects: 'Projects',
    selectProject: 'Select project',
    tags: 'Tags',
  },
  labels: {
    buildKey: 'Job key',
    featureName: 'Feature name',
    featureStatus: 'Feature status',
    failureKind: 'Failure type',
    failureSubkind: 'Failure detail',
    fileName: 'File name',
    pipelineName: 'Pipeline name',
    plannedForDateFrom: 'Planned from',
    plannedForDateTo: 'Planned to',
    project: 'Project',
    releaseName: 'Release name',
    releasedDateFrom: 'Released from',
    releasedDateTo: 'Released to',
    status: 'Status',
    suiteName: 'Suite name',
    tags: 'Tags',
    testName: 'Test name',
    testingStatus: 'Testing status',
    uploadedFrom: 'Uploaded from',
    uploadedTo: 'Uploaded to',
  },
} as const;

export type FilterLabelKey = keyof typeof filterCopy.labels;
export type FilterEmptyLabelKey = keyof typeof filterCopy.emptyLabels;

export const getFilterLabel = (key: FilterLabelKey): string => filterCopy.labels[key];
export const getFilterEmptyLabel = (key: FilterEmptyLabelKey): string =>
  filterCopy.emptyLabels[key];

export const getFilterCopySamples = (): string[] => [
  ...Object.values(filterCopy.labels),
  ...Object.values(filterCopy.emptyLabels),
];
